import React from "react";
import { useState, useEffect } from 'react';

//selectors for redux :
import { useSelector } from "react-redux";
import { getContrat } from "../../../../store/selectors.js";

import dayjs from 'dayjs';

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../../config/api-config.js';


function StepSix() { // component to manage the first step of shopping : choosing place and time

    let fullContrat = useSelector(getContrat); //global state : confirmed contrat with all infos
    //console.log(fullContrat);
    //console.log(dayjs(fullContrat.created).format("DD/MM/YYYY HH:mm"));
    const [fail, setFail] = useState(false); //state : api request failed
    let indice = 0;




    /*  useEffect(() => {
         indice++;
 
         if (indice < 2) { // we don't wa
 
            
 
 
         } //end of if indice <2
 
     }, []) */
    if (Object.keys(fullContrat).length !== 0) { // to be sure that object is not empty
        console.log("delay", fullContrat);

        let body = {
            to: "manuel.vivion@gmail.com"/* fullContrat.Client.email */,
            subject: "Confirmation de votre réservation de vélos, Contrat ref. " + fullContrat.ref_contrat,
            html: prepaMail(fullContrat)
        };

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    setFail(false); //to not trigger alert message
                    //console.log(response.data)

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })


    }






    return (
        <>
            {fail ?
                <p>Echec de l'envoie mail</p>
                :
                <p>Envoie mail réussi</p>
            }
        </>

    )
}




export default StepSix

function prepaMail(fullContrat) {
    let htmlBody = `<html lang='fr' translate="no">

    <head>
        <meta charset='UTF-8'>
        <title>Confirmation de votre réservation</title>
        <style>
            body {
                background-color: linen;
                font-family: Arial, Helvetica, sans-serif;
            }
    
            section {
                max-width: 600px;
                margin: auto;
                background-color: white;
                padding: 20px 25px;
                border-top: 1px solid #e2007a;
            }
    
            #banniere {
                text-align: center;
                height: 100px;
                width: 100%;
                padding: 10px 0px;
                background-image: linear-gradient(to bottom, #e2007a, #a10d59 35%);
                border-bottom: 5px solid #e2007a;
            }
    
            #banniere img {
                width: 250px;
                margin: auto;
            }
    
            #footer {
                text-align: center;
                font-size: 11px;
            }
    
            #rappel_infos h5 {
                margin-bottom: -5px;
            }
    
            .titre_centre {
                display: block;
                width: 100%;
                margin: auto;
                text-align: center;
                color: #e2007a;
                font-size: 16px;
                padding: 8px 4px;
                margin-top: 10px;
                border-bottom: 1px solid #e2007a;
    
    
            }
    
            h6 {
                text-align: center;
                color: #a10d59;
                margin: 3px 0px;
            }
    
            h4 {
                text-align: center;
                color: #a10d59;
                margin: 3px 0px;
            }
    
            section h6 {
                text-align: left;
                color: black;
                text-decoration: underline;
            }
    
            #titre_mail {
                text-align: center;
                color: #a10d59
            }
    
            table {
                font-family: Arial, Helvetica, sans-serif;
                border-collapse: collapse;
                width: 100%;
                margin-top: 20px;
            }
    
            th {
                background-color: #ccc;
            }
    
            tr:nth-child(odd) {
                background-color: #eee;
            }
    
            td,
            th {
                padding: 10px;
                border: 1px solid #ddd;
            }
    
            td {
                vertical-align: top;
            }
    
            td:nth-child(1) {
                text-align: center;
                width: 10%;
            }
    
            td:nth-child(2) {
                text-align: left;
                width: 30%;
            }
    
            td:nth-child(3) {
                text-align: center;
                width: 40%;
            }
    
            td:nth-child(4) {
                text-align: right;
                width: 20%;
            }
    
            #ligne_global {
                text-align: right;
                color: white;
                background-color: #e2007a;
            }
    
            #ligne_tva {
                text-align: right;
                color: white;
                background-color: #888;
            }
        </style>
    </head>
    `;

    htmlBody += `<body>
    <section id='banniere'>
        <img src='https://manuelvivion.net/nestor/bikes/images/logo-moutchic-loisirs-text-500.png' id='logo_ml'>
    </section>
    <h6>www.moutchicinn.com / +33(0)6.66.10.09.12</h6>
    <section>
        <h2 id='titre_mail'>Confirmation de votre location</h2>
        <p>Bonjour ${fullContrat.Client.prenom + " " + fullContrat.Client.nom} </p>
        <p>Merci d'avoir loué vos vélos chez Moutchic Loisirs. </p>
        <p>Si vous avez des questions sur cette location, n'hésitez pas à nous appeler au 06 66 10 09 12 </p>
        <p>Vous trouverez en pièce jointe votre <b>contrat de location</b> </p>

    </section>
    <section id='rappel_infos'>
        <h4>Rappel de vos informations : </h4>
        <h5>Ref. de votre contrat : ${fullContrat.ref_contrat}</h5>
        <p>Location faite le ${dayjs(fullContrat.created).format("DD/MM/YYYY HH:mm")}</p>`;



    htmlBody += `<div>
    <h3 class='titre_centre'>Période de location :</h3>
    <p>Du ${dayjs(fullContrat.date1).format("DD/MM/YYYY")} à ${fullContrat.h1}h00 au ${dayjs(fullContrat.date2).format("DD/MM/YYYY")} à ${fullContrat.h2}h00</p>
</div>
<div>
    <h3 class='titre_centre'>Point de retrait des vélos :</h3>
    <p>${fullContrat.Spot.nom_spot}<br>${fullContrat.Spot.adresse_spot}<br>${fullContrat.Spot.cp_spot},${fullContrat.Spot.ville_spot}<br>France<br><a
            href='https://www.google.com/maps/search/?api=1&query=${fullContrat.Spot.gps_lat},${fullContrat.Spot.gps_long}' target='_blank'>
            itinéraire </a></p>
</div>`;



    htmlBody += `<div>
    <h3 class='titre_centre'>Liste de vos vélos :</h3>

    <table>
        <tr>
            <th>Qté</th>
            <th>Article</th>
            <th>infos</th>
            <th>prix</th>
        </tr>`;


    fullContrat.ContratArticles.map((article) => {
        let infosTaille = "";
        for (let i = 0; i < article.taille.length; i++) {
            infosTaille += article.prenom[i] + ":" + article.taille[i] + "cm / ";
        }

        htmlBody += ` <tr>
        <td style='text-align:center;'>${article.qte}</td>
        <td>${article.article_id}</td>
        <td style='text-align:center;'>${infosTaille}</td>
        <td style='text-align:right;'>prix</td>
    </tr>`;

    }); //end of mapping contrat-articles

    htmlBody += `<tr>
            <td colspan='4' id='ligne_global'> montant global (déjà réglé) : ${fullContrat.total},00 €</td>
        </tr>
        <tr>
            <td colspan='4' id='ligne_tva'> dont taxe (TVA) : ${fullContrat.total * 0.2} €</td>
        </tr>

    </table>
`;

    htmlBody += ` 
        <p>Commentaire : ${fullContrat.commentaire}</p>
        <h5>- Vous avez accepté les conditions générales de vente.</h5>
        <h5>- Vous avez accepté de laisser une garantie en dépôt pour la durée de votre location.</h5>
        </div>
        <div>
        <h3 class='titre_centre'>Infos facturation :</h3>
        <p>${fullContrat.Client.prenom + " " + fullContrat.Client.nom} </p>
        <p>Email : ${fullContrat.Client.email}</p>
        <p>Tel : ${fullContrat.Client.tel}</p>
        <p>${fullContrat.Client.adresse}</p>
        <p>${fullContrat.Client.cp + ", " + fullContrat.Client.ville}</p>
        </div>
        </section>

        <section id='footer'>
        <p>Moutchic Loisirs - 7, rue de la poste 33680 Lacanau, France</p>
        </section>
        </body>

        </html>

        `;



    return htmlBody
}